export default __webpack_public_path__ + "static/media/tutor.48303508.svg";